import { makeStyles } from '@material-ui/core';

import { UserListColumn, UserListTableProps } from '@/components/shared/components/UserList/types/TableProps';

import { TableColumn } from '../../../../../config/types';
import { useScreen } from '../../../../../hooks/useScreen';

interface UseUserTableProps extends UserListTableProps {}

export const useUserTable = ({ tableProps }: UseUserTableProps) => {
  const { isMobile } = useScreen();

  const useStyles = makeStyles({
    root: {
      '& .MuiTableCell-root': {
        paddingInline: 6,
        paddingBlock: 8,
        '&:first-child': {
          paddingLeft: 0,
        },
      },
      '& .MuiTableRow-head': {
        verticalAlign: 'bottom',
      },
      '&. MuiButton-sizeSmall': {
        paddingInline: 2,
        minWidth: 10,
      },
    },
  });

  const classes = useStyles();

  const hideColumn = (columnName: UserListColumn) =>
    tableProps?.columnsToHide?.some((columnToHide) => columnToHide === columnName);

  const columnsDesktop: TableColumn[] = [
    ...(!hideColumn(UserListColumn.ICON)
      ? [{ name: 'userId', label: '', align: 'left' as const, sticky: true, colWidth: '80px' }]
      : []),
    ...(tableProps?.users ? [{ name: 'username', label: 'USERNAME', align: 'left' as const, colWidth: '300px' }] : []),
    { name: 'email', label: 'EMAIL', align: 'left', colWidth: '300px' },
    { name: 'two_factor_required', label: 'TWO_FACTOR_AUTH', align: 'left', colWidth: '50px' },
    ...(!hideColumn(UserListColumn.ROLES) ? [{ name: 'roles', label: 'ROLES', align: 'left' as const }] : []),
    { name: 'blocked', label: 'BLOCK_STATUS', align: 'left' },
    { name: 'createdAt', label: 'CREATED_AT_FOR_TABLE', align: 'left', colWidth: '140px' },
    { name: 'more_actions', label: '', align: 'right', colWidth: '24px' },
  ];

  const columnsMobile: TableColumn[] = [
    ...(tableProps?.users ? [{ name: 'username', label: 'USERNAME', align: 'left' as const, colWidth: '300px' }] : []),
    { name: 'email', label: 'EMAIL', align: 'left' },
    { name: 'two_factor_required', label: 'TWO_FACTOR_AUTH', align: 'left' },
    ...(!hideColumn(UserListColumn.ROLES) ? [{ name: 'roles', label: 'ROLES', align: 'left' as const }] : []),
    { name: 'more_actions', label: '_', align: 'center' },
  ];

  const columns = isMobile ? columnsMobile : columnsDesktop;

  return { classes, columns, hideColumn };
};
